import React from 'react';
import SidebarComponent from '../components/SidebarComponent';
import ShopPageSlidersListComponent from '../components/ShopPageSlidersListComponent';
import HeaderComponent from '../components/HeaderComponent';

class ShopPageSlidersListPage extends React.Component {
    render() {
        return (
            <div className="wrapper">
                <SidebarComponent location={this.props.location}/>
                <HeaderComponent/>
                <ShopPageSlidersListComponent location={this.props.location}/>
            </div>
        );
    }
}

export default ShopPageSlidersListPage;